export default __webpack_public_path__ + "static/media/ttd_petugas_proc.6be632ff.jpg";